{
	"title": "Fakturor",
	"buttonShowMoreInvoicesTitle": "Visa fler fakturor",
	"invoicesTableHeaders": {
		"date": "Datum",
		"invoiceNumber": "Fakturanummer",
		"deliveredQuantity": "Levererad kvantitet",
		"bundledCarbonSavings": "Bundlade koldioxidreduktioner",
		"transactionId": "Transaktions-ID"
	},
	"errorMessage": "Det gick inte att ladda fakturor"
}
